import { produce } from "immer";
import {
  FETCH_PAGES,
  FETCH_PAGES_SUCCESS,
  FETCH_PAGES_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_PAGES,
  ADD_PAGES_SUCCESS,
  ADD_PAGES_FAILURE,
  //
  EDIT_PAGES,
  EDIT_PAGES_SUCCESS,
  EDIT_PAGES_FAILURE,
  //
  DELETE_PAGES,
  DELETE_PAGES_SUCCESS,
  DELETE_PAGES_FAILURE,
  //
  OPEN_PAGES_ADD_MODAL,
  CLOSE_PAGES_ADD_MODAL,
  //
  OPEN_PAGES_EDIT_MODAL,
  CLOSE_PAGES_EDIT_MODAL,
  //
  TOGGLE_ITEM_MODAL,
  TOGGLE_SECTION_MODAL,
  TOGGLE_INNER_SECTION_MODAL,
  TOGGLE_INNER_ITEM_MODAL,
  //
  UPLOAD_FILE,
  UPLOAD_FILE_FAILURE,
  UPLOAD_FILE_SUCCESS,
} from "./constants";

export const initialState = {
  isFetchingPages: false,
  Pages: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentPages: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  //
  isAddModalOpen: false,
  isEditModalOpen: false,
  itemModal: {
    open: false,
    data: {},
  },
  sectionModal: {
    open: false,
    data: {},
  },
  innerSectionModal: {
    open: false,
    data: {},
  },
  innerItemModal: {
    open: false,
    data: {},
  },
  //
  isUploadingFile: false,
};

const PagesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_PAGES:
        draft.isFetchingPages = true;
        draft.currentPages = {};
        break;
      case FETCH_PAGES_SUCCESS:
        draft.isFetchingPages = false;
        draft.Pages = action.payload;
        break;
      case FETCH_PAGES_FAILURE:
        draft.isFetchingPages = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentPages = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentPages = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_PAGES:
        draft.isSubmitting = true;
        break;
      case ADD_PAGES_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_PAGES_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_PAGES:
        draft.isSubmitting = true;
        break;
      case EDIT_PAGES_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_PAGES_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_PAGES:
        draft.isDeleting = true;
        break;
      case DELETE_PAGES_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_PAGES_FAILURE:
        draft.isDeleting = false;
        break;

      case OPEN_PAGES_ADD_MODAL:
        draft.isAddModalOpen = true;
        draft.isEditModalOpen = false;
        draft.currentPages = {};
        break;
      case CLOSE_PAGES_ADD_MODAL:
        draft.isAddModalOpen = false;
        draft.isEditModalOpen = false;
        draft.currentPages = {};
        break;

      case OPEN_PAGES_EDIT_MODAL:
        draft.isEditModalOpen = true;
        draft.isAddModalOpen = false;
        draft.currentPages = {};
        break;
      case CLOSE_PAGES_EDIT_MODAL:
        draft.isEditModalOpen = false;
        draft.isAddModalOpen = false;
        draft.currentPages = {};
        break;

      case TOGGLE_ITEM_MODAL:
        draft.itemModal = action.payload;
        break;
      case TOGGLE_SECTION_MODAL:
        draft.sectionModal = action.payload;
        break;
      case TOGGLE_INNER_SECTION_MODAL:
        draft.innerSectionModal = action.payload;
        break;
      case TOGGLE_INNER_ITEM_MODAL:
        draft.innerItemModal = action.payload;
        break;

      case UPLOAD_FILE:
        draft.isUploadingFile = true;
        break;
      case UPLOAD_FILE_SUCCESS:
        draft.isUploadingFile = false;
        break;
      case UPLOAD_FILE_FAILURE:
        draft.isUploadingFile = false;
        break;

      default:
        return state;
    }
  });

export default PagesReducer;
